// transport.constants.js

export const GET_TRANSPORT_REPORT = "GET_TRANSPORT_REPORT"
export const GET_TRANSPORT_REPORT_REQUEST = "GET_TRANSPORT_REPORT_REQUEST"
export const GET_TRANSPORT_REPORT_SUCCESS = "GET_TRANSPORT_REPORT_SUCCESS"
export const GET_TRANSPORT_REPORT_FAILURE = "GET_TRANSPORT_REPORT_FAILURE"

export const TRANSPORT_REPORT_RESET = "TRANSPORT_REPORT_RESET"